<template>
  <gg-card>
    <gg-card-header>
      Review
    </gg-card-header>
    <gg-card-text>
      <v-row class="pt-2">
        <v-col cols="12" md="6">
          <p class="mb-0">
            <b>Website Type: </b> {{ starterSite.website_type }}
          </p>
        </v-col>
        <v-col cols="12" md="6">
          <p class="mb-0">
            <b>Website Name: </b> {{ starterSite.website_name }}
          </p>
        </v-col>
        <v-col cols="12" md="6">
          <p class="mb-0">
            <b>About Website: </b>
            <span v-no-data="starterSite.contentAbout"></span> &nbsp;
          </p>
        </v-col>
        <v-col cols="12" md="6">
          <p class="mb-0">
            <b>Website Purpose: </b>
            <span v-no-data="starterSite.website_description"></span> &nbsp;
          </p>
        </v-col>
        <v-col cols="12">
          <p class="mb-2">
            <b>Products & Services: </b>
            <span
              v-show="!starterSite.contentServices.filter(cs => !!cs).length"
              class="mb-0 grey--text text--darken-3"
            >
              Not Specified
            </span>
          </p>
          <p
            v-for="(service, index) in starterSite.contentServices"
            :key="`r-ps${index}`"
            v-html="service"
            class="mb-2"
          ></p>
        </v-col>
        <v-col cols="12" md="6">
          <p class="mb-0">
            <b>Email Address: </b>
            <span v-no-data="starterSite.companyEmail"></span>
          </p>
        </v-col>
        <v-col cols="12" md="6">
          <p class="mb-0">
            <b>Phone Number: </b>
            <span v-no-data="starterSite.companyPhone"></span>
          </p>
        </v-col>
        <v-col cols="12" md="6">
          <p class="mb-0">
            <b>Facebook Link: </b>
            <span v-no-data="starterSite.socialFacebook"></span>
          </p>
        </v-col>
        <v-col cols="12" md="6">
          <p class="mb-0">
            <b>Twitter Link: </b>
            <span v-no-data="starterSite.socialTwitter"></span>
          </p>
        </v-col>
        <v-col cols="12" md="6">
          <p class="mb-0">
            <b>Instagram Link: </b>
            <span v-no-data="starterSite.socialInstagram"></span>
          </p>
        </v-col>
        <v-col cols="12" md="6">
          <p class="mb-0">
            <b>Pinterest Link: </b>
            <span v-no-data="starterSite.socialPintrest"></span>
          </p>
        </v-col>
        <v-col cols="12" md="6">
          <p class="mb-0">
            <b>LinkedIn Link: </b>
            <span v-no-data="starterSite.socialLinkedIn"></span>
          </p>
        </v-col>
        <v-col v-if="starterSite.businessHours" cols="12" class="mt-2">
          <p class="font-weight-bold mb-0">Business Hours:</p>
          <p v-for="(day, i) in days" :key="`r-d${i}`" class="mt-4 mb-0">
            <b>{{ day }}</b>
            Open At:
            <span v-no-data="starterSite['hoursOpen' + day]"></span>
            Close At:
            <span v-no-data="starterSite['hoursClosed' + day]"></span>
          </p>
        </v-col>
        <template v-if="starterSite.physicalAddress">
          <v-col cols="12" md="6">
            <p class="mb-0">
              <b>Address:</b>&nbsp;
              <span v-no-data="starterSite.contactAddress"></span>
            </p>
          </v-col>
          <v-col cols="12" md="6">
            <p class="mb-0">
              <b>Country:</b>&nbsp;
              <span v-no-data="starterSite.contactCountry"></span>
            </p>
          </v-col>
          <v-col cols="12" md="6">
            <p class="mb-0">
              <b>State:</b>&nbsp;
              <span v-no-data="starterSite.contactState"></span>
            </p>
          </v-col>
          <v-col cols="12" md="6">
            <p class="mb-0">
              <b>City:</b>&nbsp;
              <span v-no-data="starterSite.contactCity"></span>
            </p>
          </v-col>
          <v-col cols="12" md="6">
            <p class="mb-0">
              <b>Postcode:</b>&nbsp;
              <span v-no-data="starterSite.contactPostcode"></span>
            </p>
          </v-col>
        </template>
        <v-col cols="12">
          <p class="font-weight-bold">Website Layout:</p>
          <v-img :src="themeImage(theme)"
                 position="top"
                 height="860"
                 max-height="860"
                 max-width="250">
          </v-img>
        </v-col>
      </v-row>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { themeImage } from 'Helpers/wizard'

const handleNoData = (el, binding) => {
  if (!binding.value) {
    el.classList.add('grey--text', 'text--darken-3')
    el.innerHTML = 'Not Specified'
  } else {
    el.innerHTML = binding.value
    el.classList.remove('grey--text', 'text--darken-3')
  }
}

const vNoData = {
  bind: handleNoData,
  update: handleNoData
}

export default {
  name: 'Review',
  directives: {
    noData: vNoData
  },
  data () {
    return {
      days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    }
  },
  computed: {
    ...mapGetters({
      starterSite: 'wizard_model/starterSite',
      theme: 'wizard_model/theme'
    })
  },
  methods: {
    validate () {
      return true
    },
    themeImage,
  },
}
</script>

<style scoped>

</style>
